import styled from 'styled-components';
import { font } from 'styles';

export const Button = styled.button`
  padding: 10px 20px;
  cursor: pointer;
  text-transform: uppercase;
  ${font.size(15)}
`;